import { TaipeiDate } from "../../../../../utils/taipeiDate.js";
/**
 * @function ApiClient#GetCalendarEvents
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} year = new TaipeiDate().getFullYear()
 * @param {any} month = new TaipeiDate().getMonth() + 1
 * @param {any} options = {}
 */
export async function GetCalendarEvents(cid, year = new TaipeiDate().getFullYear(), month = new TaipeiDate().getMonth() + 1, options = {}) {
  const args = {
    "year=": year,
    "month=": month,
  };
  const url = Object.keys(args).reduce((acc, value, index) => {
    return acc + (index === 0 ? "?" : "&") + value + args[value];
  }, `/community/${cid}/maintenance/calendar`);
  return await this._get(url, options);
}
